define('builderShowcaseObserver',[
  'builderShowcaseState',
  'eventBus'
], (builderShowcaseState) => {
  'use strict';

  const eventBus = new window.NewHomeSource.EventBus();
  const temporalState = builderShowcaseState.getState();

  /**
  * @public
  * beforeMapResultsLoaded: event to be executed before the map results are retrieved in a AJAX request.
  * @param {object} data collected from the module that trigger the event.
  */
  function beforeMapResultsLoaded(data) {
    eventBus.notifyObservers('onBeforeMapResultsLoaded', data);
  }

  /**
  * @public
  * OnSortByChanged: executed after sort by changes.
  * @param {object} data collected from the module that trigger the event.
  */
  function OnSortByChanged(data) {
    eventBus.notifyObservers('OnSortByChanged', data);
  }

  /**
  * @public
  * OnPageSizeChanged: executed after page size changes.
  * @param {object} data collected from the module that trigger the event.
  */
  function OnPageSizeChanged(data) {
    eventBus.notifyObservers('OnPageSizeChanged', data);
  }

  /**
  * @public
  * OnSortByChanged: executed after star filter changes.
  * @param {object} data collected from the module that trigger the event.
  */
  function OnStarFilterChanged(data) {
    eventBus.notifyObservers('OnStarFilterChanged', data);
  }

  /**
  * @public
  * OnSortByChanged: executed after star filter changes.
  * @param {object} data collected from the module that trigger the event.
  */
  function PaginationChanged(data) {
    eventBus.notifyObservers('PaginationChanged', data);
  }

  /**
  * @public
  * OnSortByChanged: executed after sort by changes.
  * @param {object} data collected from the module that trigger the event.
  */
  function onReviewsSectionLoaded(data) {
    eventBus.notifyObservers('onReviewsSectionLoaded', data);
  }

  /**
  * @public
  * afterMapResultsLoaded: event to be executed after the map results are retrieved in a AJAX request.
  * @param {object} data collected from the module that trigger the event.
  */
  function afterMapResultsLoaded(data) {
    eventBus.notifyObservers('onAfterMapResultsLoaded', data);
  }

  /**
  * @public
  * galleryOpened: event to be executed when the gallery is opened in the about page.
  * @param {object} data collected from the module that trigger the event.
  */
  function galleryOpened(data) {
    eventBus.notifyObservers('onGalleryOpened', data);
  }

  /**
  * @public
  * onResize: event to be executed whenever the device changes it's dimensions.
  * @param {object} data collected from the module that trigger the event.
  */
  function onResize(data) {
    eventBus.notifyObservers('onResize', data);
  }

  /**
  * @public
  * imageSelected: event to be executed whenever a new image is selected.
  * @param {object} data collected from the module that trigger the event.
  */
  function imageSelected(data) {
    eventBus.notifyObservers('onImageSelected', data);
  }

  /**
  * @public
  * modalImageSelected: event to be executed whenever a new modal image is selected.
  * @param {object} data collected from the module that trigger the event.
  */
  function modalImageSelected(data) {
    eventBus.notifyObservers('onModalImageSelected', data);
  }

  /**
  * @public
  * onGalleryClosed: event to be executed whenever a modal is closed.
  * @param {object} data collected from the module that trigger the event.
  */
  function onGalleryClosed(data) {
    eventBus.notifyObservers('onGalleryClosed', data);
  }

  /**
  * @public
  * navigateToImage: event to be executed whenever a navigation button is selected.
  * @param {object} data collected from the module that trigger the event.
  */
  function navigateToImage(data) {
    eventBus.notifyObservers('onNavigateToImage', data);
  }

  /**
  * @public
  * navigateToModalImage: event to be executed whenever a navigation modal button is selected.
  * @param {object} data collected from the module that trigger the event.
  */
  function navigateToModalImage(data) {
    eventBus.notifyObservers('onNavigateToModalImage', data);
  }

  /**
  * @public
  * subscribe: represents the way that modules uses for subscribing to the BSP publisher.
  * @param {string} topic represents the name of an event to be observed.
  * @param {function} observer represents a callback to be executed when the topic event gets triggered.
  */
  function subscribe(topic, observer) {
    eventBus.addObserver(topic, observer);
  }

  /**
* @public
* setSearchParamAttribute: sets a single search param value.
* @param {string} key to access on search params object.
* @param {object} value to change in a given attribute.
*/
  function setSearchParamAttribute(key, value) {
    if (!key ||
      !value ||
      !Object.prototype.hasOwnProperty.call(temporalState.searchParameters, key)) {
      return;
    }

    temporalState.searchParameters[key] = value;
  }

  /**
  * @public
  * setSearchParamsAttributes: modifies a set of attributes in search params.
  * @param {object} object with a set of attributes to change on search params.
  */
  function setSearchParamsAttributes(object) {
    if (!object) {
      return;
    }

    const objectEntries = Object.entries(object);

    for (let i = 0; i < objectEntries.length; i += 1) {
      temporalState.searchParameters[objectEntries[i][0]] = objectEntries[i][1];
    }
  }

  /**
  * @public
  * setData: modifies a set of attributes in the data.
  * @param {object} object with a set of attributes to change on the data.
  */
  function setData(object) {
    if (!object) {
      return;
    }

    const objectEntries = Object.entries(object);

    for (let i = 0; i < objectEntries.length; i += 1) {
      temporalState.data[objectEntries[i][0]] = objectEntries[i][1];
    }
  }

  /**
  * @public
  * commit: changes the state object.
  */
  function commit() {
    builderShowcaseState.setSearchParamsAttributes(temporalState.searchParameters);
    builderShowcaseState.setData(temporalState.data);
  }

  /**
  * @public
  * getParameter: gets a single parameter on the search parameters.
  * @param {string} key to access the search param object.
  */
  function getParameter(key) {
    const state = builderShowcaseState.getState();
    if (Object.prototype.hasOwnProperty.call(state.searchParameters, key)) {
      return state[key];
    }

    return null;
  }

  /**
  * @public
  * getState: gets the full state of the bulder show case
  */
  function getState() {
    return builderShowcaseState.getState();
  }

  /**
  * @public
  * getOriginalLatitude: gets the latitude to be consiedered for BSP
  */
  function getOriginalLatitude() {
    const value = parseFloat(temporalState.searchParameters.OriginLat);
    return value;
  }

  /**
  * @public
  * getOriginalLongitude: gets the longitud to be consiedered for BSP
  */
  function getOriginalLongitude() {
    const value = parseFloat(temporalState.searchParameters.OriginLng);
    return value;
  }

  /**
  * @public
  * getZoomLevel: gets the zoom level to use for BSP
  */
  function getZoomLevel() {
    return temporalState.searchParameters.Zoom;
  }

  /**
  * @public
  * getParameters: gets the full search parameter object
  */
  function getParameters() {
    return builderShowcaseState.getParameters();
  }

  /**
  * @public
  * getBrandId: gets the brand id from state
  */
  function getBrandId() {
    return temporalState.data.BrandId;
  }

  temporalState.searchParameters.PartnerId = temporalState.parterId;
  temporalState.searchParameters.BrandId = getBrandId();
  commit();

  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', onResize);

  return {
    beforeMapResultsLoaded,
    afterMapResultsLoaded,
    OnSortByChanged,
    OnStarFilterChanged,
    OnPageSizeChanged,
    PaginationChanged,
    onReviewsSectionLoaded,
    galleryOpened,
    onResize,
    imageSelected,
    modalImageSelected,
    navigateToImage,
    navigateToModalImage,
    subscribe,
    commit,
    setParameter: setSearchParamAttribute,
    setParameters: setSearchParamsAttributes,
    getParameter,
    getParameters,
    getState,
    setData,
    getOriginalLatitude,
    getOriginalLongitude,
    getZoomLevel,
    onGalleryClosed,
  };
});

